import React from "react";
import ListItem from "@mui/material/List";
import {NavLink} from "react-router-dom";
import {Link} from "react-scroll";

const menus = [
  {
    id: 1,
    title: "Nuestras ventajas",
    link: "id_ico_about_section",
    isScroll: true,
  },
  {
    id: 2,
    title: "¿Por qué CruCoin?",
    link: "id_ico_service_section",
    isScroll: true,
  },
  {
    id: 3,
    title: "Contacto",
    link: "/contact",
    isScroll: false,
  },
];

const MobileMenu = () => {
  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  return (
    <ul className="mobail-menu main_menu_list unordered_list text-uppercase">
      {menus.map((item, mn) => {
        return (
          <ListItem key={mn}>
            {item.isScroll ? (
              <Link
                to={item.link}
                spy={true}
                smooth={true}
                duration={500}
                offset={-100}
                className="nav-link scrollspy_btn"
                onClick={ClickHandler}
              >
                <span className="nav_link_label" data-text={item.title}>
                  {item.title}
                </span>
              </Link>
            ) : (
              <NavLink
                className="nav-link"
                to={item.link}
                onClick={ClickHandler}
              >
                <span className="nav_link_label" data-text={item.title}>
                  {item.title}
                </span>
              </NavLink>
            )}
          </ListItem>
        );
      })}
    </ul>
  );
};

export default MobileMenu;
